import { SeismicMetadataPopup } from 'features/seismic/components/metadata/SeismicMetadataPopup';
import { use3DGridStore } from '../stores/use3DGridStore';

export type Seismic3DMetadataPopupProps = {
    opened: boolean,
    onChangeOpened: (val: boolean) => void,
};

export const Seismic3DMetadataPopup = ({ opened, onChangeOpened }: Seismic3DMetadataPopupProps) => {
    const selectedVolumes = use3DGridStore(state => state.selectedVolumes);

    return (
        <SeismicMetadataPopup volumesMetadata={selectedVolumes} opened={opened} setOpened={onChangeOpened}/>
    );
};